/**
 * Panel page uuids — a contract with Core (App\Enums\PanelPage) and AddZone grants.
 * Never change one; only add.
 */
export const PANEL_PAGES = {
  Dashboard: '01928c00-0000-7000-8000-000000000001',
  Work: '01928c00-0000-7000-8000-000000000002',
  Accounts: '01928c00-0000-7000-8000-000000000003',
  Contacts: '01928c00-0000-7000-8000-000000000004',
  Leads: '01928c00-0000-7000-8000-000000000005',
  Opportunities: '01928c00-0000-7000-8000-000000000006',
  Activities: '01928c00-0000-7000-8000-000000000007',
  Notes: '01928c00-0000-7000-8000-000000000008',
  Offers: '01928c00-0000-7000-8000-000000000009',
  Reports: '01928c00-0000-7000-8000-000000000010',
  Search: '01928c00-0000-7000-8000-000000000011',
  Catalogue: '01928c00-0000-7000-8000-000000000012',
  OfferTemplates: '01928c00-0000-7000-8000-000000000013',
  SettingsPipelines: '01928c00-0000-7000-8000-000000000014',
  SettingsFields: '01928c00-0000-7000-8000-000000000015',
  SettingsDictionaries: '01928c00-0000-7000-8000-000000000016',
  SettingsNumbering: '01928c00-0000-7000-8000-000000000017',
  SettingsCurrencies: '01928c00-0000-7000-8000-000000000018',
  SettingsTags: '01928c00-0000-7000-8000-000000000019',
  SettingsDuplicates: '01928c00-0000-7000-8000-000000000020',
  SettingsAssignment: '01928c00-0000-7000-8000-000000000021',
  SettingsSequences: '01928c00-0000-7000-8000-000000000022',
  SettingsViews: '01928c00-0000-7000-8000-000000000023',
  SettingsBranding: '01928c00-0000-7000-8000-000000000024',
  SettingsOffline: '01928c00-0000-7000-8000-000000000025',
  SettingsDevices: '01928c00-0000-7000-8000-000000000026',
  SettingsAudit: '01928c00-0000-7000-8000-000000000027',
  SettingsGeneral: '01928c00-0000-7000-8000-000000000028',
  Profile: '01928c00-0000-7000-8000-000000000029',
  Competitors: '01928c00-0000-7000-8000-000000000030',
  Campaigns: '01928c00-0000-7000-8000-000000000031',
  MarketingLists: '01928c00-0000-7000-8000-000000000032',
  Events: '01928c00-0000-7000-8000-000000000033',
  SettingsData: '01928c00-0000-7000-8000-000000000034',
  Contracts: '01928c00-0000-7000-8000-000000000035',
  SettingsContracts: '01928c00-0000-7000-8000-000000000036',
  SettingsSpeech: '01928c00-0000-7000-8000-000000000038',
  SettingsApprovals: '01928c00-0000-7000-8000-000000000039',
  SettingsAi: '01928c00-0000-7000-8000-00000000003a',
  SettingsCatalogueNaming: '01928c00-0000-7000-8000-00000000003b',
  Agreements: '01928c00-0000-7000-8000-000000000037',
}

export const ENTITY_PAGES = {
  account: PANEL_PAGES.Accounts,
  contact: PANEL_PAGES.Contacts,
  lead: PANEL_PAGES.Leads,
  opportunity: PANEL_PAGES.Opportunities,
  activity: PANEL_PAGES.Activities,
  note: PANEL_PAGES.Notes,
  offer: PANEL_PAGES.Offers,
  competitor: PANEL_PAGES.Competitors,
  campaign: PANEL_PAGES.Campaigns,
  marketing_list: PANEL_PAGES.MarketingLists,
  event: PANEL_PAGES.Events,
  contract: PANEL_PAGES.Contracts,
  agreement: PANEL_PAGES.Agreements,
}

/**
 * Where to send someone whose start page is not granted: the first screen, in menu order,
 * that they may open — or null when they have none of AddCRM yet.
 */
const START_ORDER = [
  [PANEL_PAGES.Dashboard, { name: 'dashboard' }],
  [PANEL_PAGES.Work, { name: 'work' }],
  ...['accounts', 'contacts', 'leads', 'opportunities', 'activities', 'notes', 'offers', 'competitors', 'campaigns', 'marketing-lists', 'events', 'contracts', 'agreements'].map((p) => [
    { accounts: PANEL_PAGES.Accounts, contacts: PANEL_PAGES.Contacts, leads: PANEL_PAGES.Leads, opportunities: PANEL_PAGES.Opportunities, activities: PANEL_PAGES.Activities, notes: PANEL_PAGES.Notes, offers: PANEL_PAGES.Offers, competitors: PANEL_PAGES.Competitors, campaigns: PANEL_PAGES.Campaigns, 'marketing-lists': PANEL_PAGES.MarketingLists, events: PANEL_PAGES.Events, contracts: PANEL_PAGES.Contracts, agreements: PANEL_PAGES.Agreements }[p],
    { name: 'list', params: { entityPath: p } },
  ]),
  [PANEL_PAGES.Catalogue, { name: 'catalogue' }],
  [PANEL_PAGES.OfferTemplates, { name: 'templates' }],
  [PANEL_PAGES.Reports, { name: 'reports' }],
]
export function firstAllowedRoute(canViewPage) {
  const hit = START_ORDER.find(([page]) => canViewPage(page))
  if (hit) return hit[1]
  return Object.entries(PANEL_PAGES).some(([k, v]) => k.startsWith('Settings') && canViewPage(v)) ? { name: 'settings' } : null
}
